import { usePageLocation } from '../../../features/page';
import { useCurrentArtistIdOrNull } from './useCurrentArtistIdOrNull';

export function useCurrentArtistId() {
  const artistIdOrNull = useCurrentArtistIdOrNull();
  const location = usePageLocation();
  if (!artistIdOrNull) {
    throw new Error(`${location.pathname} doesn't match /artist/:artistId`);
  }

  return artistIdOrNull;
}
